<script setup lang="ts">
const whatsNext = [
  {
    text: 'Accedi!',
    href: 'login',
  },
];
</script>

<template>
  <div class="land d-flex flex-column align-center flex-0-0 flex-wrap">
    <v-img
      alt="Prosafe Logo"
      class="shrink mainlogo"
      contain
      src="/images/Prosafe_800.png"
      transition="scale-transition"
      width="250"
      height="250"
    />
    <h1 class="text-h3 font-weight-bold mb-3">Benvenuti nel nuovo prosafe!</h1>
    <h2 class="text-h5 font-weight-bold mb-3">E ora?</h2>
    <v-btn
      v-for="(next, i) in whatsNext"
      :key="i"
      :to="next.href"
      class="subheading mx-3"
      target="_blank"
    >
      {{ next.text }}
    </v-btn>
  </div>
</template>

<style scoped>
.mainlogo {
  margin-top: 30px;
  filter: grayscale(100%);
}

.land {
  padding-top: 200px;
}
</style>
